import React from 'react';
import classNames from 'classnames';
import { Link as RouteLink } from 'react-router-dom';
import { Skeleton } from '../layout/loading';

export default function Link({ to, className = '', children, loading = false, ...props }) {
  if (loading) {
    return (
      <Skeleton
        className={classNames(
          'rounded-md h-9',
          !className.includes('w-') && 'w-24',
          className
        )}
      />
    );
  }

  const linkClassNames = classNames(
    'font-semibold text-indigo-400 hover:text-indigo-300 cursor-pointer',
    className
  );
  
  return (
    <RouteLink to={to} className={linkClassNames} {...props}>
      {children}
    </RouteLink>
  );
}
